import React from "react";
import { Link } from "react-router-dom";

const Error = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="font-bold text-2xl text-red-500">
        404
      </h1>
      <p className="text-xl">Sayfa Bulunamadı.</p>
      <p className="text-gray-600">Aradığınız Sayfa Mevcut Değil.</p>
      <Link to="/firstpage" className="font-bold no-underline text-blue-600">
        Ana Sayfa
      </Link>
    </div>
  );
};

export default Error;
